import { Injectable } from '@angular/core';
import { FormQuestion, FormQuestionTypes, PpmForm, PpmFormWithQuestions } from './types/forms';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormManagementService {

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) { }

  getEmptyForm(): PpmFormWithQuestions {
    return {
      active: 0,
      id: 0,
      name: "",
      instructions: "",
      questions: [],
      uuid: "",
      translations: []
    }
  }

  getEmptyQuestion(): FormQuestion {
    return {
      id: 0,
      active: 1,
      formId: 0,
      required: 0,
      text: "",
      reportText: "",
      scaleLow: "",
      scaleHigh: "",
      type: FormQuestionTypes.Text,
      options: [],
      order: 0,
      translations: []
    }
  }

  getAllForms(): Observable<PpmForm[]> {
    return this.http.get<PpmForm[]>(`${this.config.dataApiUrl}/forms-management/forms`, { params: { includeInactive: true } })
  }


  getActiveForms(): Observable<PpmForm[]> {
    return this.http.get<PpmForm[]>(`${this.config.dataApiUrl}/forms-management/forms`)
  }

  createForm(data: Pick<PpmForm, "name">): Observable<PpmForm> {
    return this.http.post<PpmForm>(`${this.config.dataApiUrl}/forms-management/forms`, data)
  }

  getForm(formId: number): Observable<PpmFormWithQuestions> {
    return this.http.get<PpmFormWithQuestions>(`${this.config.dataApiUrl}/forms-management/forms/${formId.toString()}`)
  }


  updateForm(formId: number, data: Partial<Pick<PpmForm, "name" | "instructions" | "active" | "translations">>) {
    return this.http.patch<PpmForm>(`${this.config.dataApiUrl}/forms-management/forms/${formId.toString()}`, data)
  }

  createOrUpdateQuestions(formId: number, questions: FormQuestion[]) {
    return this.http.post<FormQuestion>(`${this.config.dataApiUrl}/forms-management/forms/${formId.toString()}/questions`, questions)
  }

  updateStaffResponseForm(formId: number) {
    return this.http.post(`${this.config.dataApiUrl}/forms-management/staff-post-trip-report-form`, {formId: formId})
  }

  updatePartnerSurveyForm(formId: number) {
    return this.http.post(`${this.config.dataApiUrl}/forms-management/partner-post-trip-survey-form`, {formId: formId})
  }

}
